import { DeleteNotificationIndexedDB } from "@/IndexedDB/notificationIndexedDB";
import {
  AddTabToIndexedDB,
  CheckIndexedDBIsSupport,
  DeleteTabFromIndexedDB,
  GetAllTabsFromIndexedDB,
  GetTabByIdFromIndexedDB,
  RemoveTabFromIndexedDB,
  UpdateTabMerchantIdToIndexedDB,
} from "@/IndexedDB/tabIndexedDB";
import { CheckBroadcastIsSupport } from "@/broadcastChannel/tabChannel";
import Cookies from "js-cookie";
import { CheckStatusSocket, SocketConnect } from "./notificationHelper";

const sessionStorageTabIdKey = "tabId";
const masterNotificationTabIdKey = "masterPeakBoardNotificationTab";

export const GetTabIdFromSessionStorage = () => {
  const tabId = sessionStorage.getItem(sessionStorageTabIdKey);
  return tabId ? parseInt(tabId) : 0;
};

const SetTabIdFromSessionStorage = (tabId: number) => {
  sessionStorage.setItem(sessionStorageTabIdKey, tabId.toString());
};

const GetMasterNotificationTabFromLocalStorage = () => {
  const masterTabId = Cookies.get(masterNotificationTabIdKey);
  return masterTabId ? parseInt(masterTabId) : 0;
};

const SetMasterNotificationTabFromLocalStorage = (tabId: number) => {
  Cookies.set(masterNotificationTabIdKey, tabId.toString());
};

const RemoveMasterNotificationTabFromLocalStorage = () => {
  Cookies.remove(masterNotificationTabIdKey);
};

const RemoveMasterNotificationTabFromSessionStorage = () => {
  sessionStorage.removeItem(sessionStorageTabIdKey);
};

export const IsMasterTab = () => {
  if (CheckBroadcastIsSupport() && CheckIndexedDBIsSupport()) {
    const tabId = GetTabIdFromSessionStorage();
    const masterTabId = GetMasterNotificationTabFromLocalStorage();
    return masterTabId == tabId;
  } else {
    return true;
  }
};
export const IsMasterTabAvailable = () => {
  const masterTabId = GetMasterNotificationTabFromLocalStorage();
  return masterTabId > 0;
};

export const ClearTabFromSessionStorage = () => {
  RemoveMasterNotificationTabFromSessionStorage();
};

export const ClearTabFromLocalStorage = () => {
  RemoveMasterNotificationTabFromLocalStorage();
};

const SetMasterBase = (tabId: number) => {
  SetMasterNotificationTabFromLocalStorage(tabId);
  CheckStatusSocket();
};

export const SetMasterTab = () => {
  const tabId = GetTabIdFromSessionStorage();
  if (!IsMasterTabAvailable()) {
    SetMasterBase(tabId);
  }
};

const SetTabID = (tabId: number) => {
  SetTabIdFromSessionStorage(tabId);
};

export const InsertTabIdToTabDB = async () => {
  const tabId = await AddTabToIndexedDB();
  if (tabId > 0) {
    SetTabID(tabId);
    SetMasterTab();
    SocketConnect();
  }
};

export const UpdateTabMerchantId = async (merchantId: number) => {
  const tabId = GetTabIdFromSessionStorage();
  if (tabId) {
    await UpdateTabMerchantIdToIndexedDB(tabId, merchantId);
  }
};

export const ClearTabDB = async () => {
  const tabs = await GetAllTabsFromIndexedDB();
  if (!tabs || tabs.length == 0) {
    await DeleteTabFromIndexedDB();
    await DeleteNotificationIndexedDB();
  }
};

export const RemoveTabDB = async (tabId: number) => {
  await RemoveTabFromIndexedDB(tabId);
};

export const GetAllTabs = async () => {
  return await GetAllTabsFromIndexedDB();
};

export const GetTabById = async (tabId: number) => {
  return await GetTabByIdFromIndexedDB(tabId);
};
